let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kyxE8")).then(() => parcelRequire('lCHRl'));